import React, { useEffect, useState } from "react";
import { Card, Badge, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "../services/axiosInterceptor";
import { getUserId } from "../services/authorize";
import { useLoading } from "../contexts/LoadingContext";
import { useLanguage } from "../contexts/LanguageContext";
import th   from "../locales/islamic/th";
import jawi from "../locales/islamic/jawi";

// การ์ดทางลัดบนหน้าห้องเรียนของฉัน — คีย์ชี้ไปที่ t.advisorHome.* ของทั้งสองภาษา
const CARDS = [
  { to: "/islamic/advisor/students",  icon: "ri-user-3-line",         variant: "primary", title: "cardStudentsTitle", desc: "cardStudentsDesc", btn: "cardStudentsBtn" },
  { to: "/islamic/advisor/timetable", icon: "ri-table-line",          variant: "secondary", title: "cardTimetableTitle", desc: "cardTimetableDesc", btn: "cardTimetableBtn" },
  { to: "/islamic/advisor/grades",    icon: "ri-bar-chart-box-line",  variant: "success", title: "cardGradesTitle",   desc: "cardGradesDesc",   btn: "cardGradesBtn" },
  { to: "/islamic/advisor/dormitory", icon: "ri-home-8-line",         variant: "warning", title: "cardDormTitle",     desc: "cardDormDesc",     btn: "cardDormBtn" },
  { to: "/islamic/advisor/leave",     icon: "ri-calendar-close-line", variant: "info",    title: "cardLeaveTitle",    desc: "cardLeaveDesc",    btn: "cardLeaveBtn" },
];

export default function IslamicAdvisorHome() {
  const { setLoading } = useLoading();
  const { lang } = useLanguage();
  const t = lang === 'th' ? th : jawi;

  const [yearId, setYearId] = useState(() => localStorage.getItem("yearId") || null);
  const [yearList, setYearList] = useState([]);
  const [room, setRoom] = useState(null);
  const [noRoom, setNoRoom] = useState(false);

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`)
      .then(res => {
        const list = res.data;
        setYearList(list);
        let id = localStorage.getItem("yearId");
        if (!id && list.length > 0) { id = list[0].year_id; localStorage.setItem("yearId", id); }
        setYearId(id);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!yearId) return;
    const t_id = getUserId();
    setLoading(true);
    setNoRoom(false);
    axiosInstance.get(`${process.env.REACT_APP_API}/islamic-advisor/myRoom/${t_id}/${yearId}`)
      .then(res => setRoom(res.data))
      .catch(err => {
        setRoom(null);
        if (err.response?.status === 404) setNoRoom(true);
      })
      .finally(() => setLoading(false));
  }, [yearId, setLoading]);

  return (
    <React.Fragment>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="main-title mb-0">{t.advisorHome.pageTitle}</h4>
        <select
          className="form-select w-auto"
          value={yearId || ""}
          onChange={e => { localStorage.setItem("yearId", e.target.value); setYearId(e.target.value); }}
        >
          {yearList.map(y => (
            <option key={y.year_id} value={y.year_id}>{t.common.studyYear(y.year_year)}</option>
          ))}
        </select>
      </div>

      {noRoom && (
        <Card className="card-one">
          <Card.Body className="text-center text-secondary py-5">
            <i className="ri-information-line fs-3 d-block mb-2"></i>
            {t.advisorHome.noRoom}
          </Card.Body>
        </Card>
      )}

      {room && (
        <>
          <Card className="card-one mb-4">
            <Card.Body>
              <div className="d-flex align-items-center gap-4">
                <div>
                  <h5 className="fw-bold mb-1">{t.common.classNo(room.ic_class, room.ir_no)}</h5>
                  <div className="d-flex gap-2 align-items-center flex-wrap">
                    <Badge bg="info">{room.is_programCode}</Badge>
                    <Badge bg={room.ir_gender === 'm' ? 'primary' : 'danger'}>{room.ir_gender === 'm' ? t.common.male : t.common.female}</Badge>
                    <span className="text-secondary small">{t.common.studyYear(room.year_year)}</span>
                  </div>
                </div>
                <div className="ms-auto text-end">
                  <div className="text-muted small">{t.advisorHome.labelStudents}</div>
                  <div className="fs-3 fw-bold text-primary">{room.student_count}</div>
                </div>
                <div className="text-end">
                  <div className="text-muted small">{t.advisorHome.labelSubjects}</div>
                  <div className="fs-3 fw-bold text-success">{room.subject_count}</div>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Row className="g-3">
            {CARDS.map(card => (
              <Col md={6} xl={3} key={card.to}>
                <Card className="card-one h-100">
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center py-4">
                    <i className={`${card.icon} fs-1 text-${card.variant} mb-2`}></i>
                    <h6 className="fw-semibold mb-1">{t.advisorHome[card.title]}</h6>
                    <p className="text-secondary small text-center mb-3">{t.advisorHome[card.desc]}</p>
                    <Link to={card.to} className={`btn btn-${card.variant} btn-sm px-4 mt-auto`}>
                      <i className="ri-arrow-right-line me-1"></i>{t.advisorHome[card.btn]}
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </React.Fragment>
  );
}
